import type {Appraiser} from '@/domain/entities/Appraiser';
import type {AppraiserDto} from './AppraiserDto';

export const toDomain = (dto: AppraiserDto): Appraiser => ({
  ...dto,
});
